// extracted by css-extract-rspack-plugin
export default {"activityToast":"src-modules-desktop-modules-files-integration-components-FileUploadProgressToast-FileUploadProgressToast-module__activityToast-GFFmD1"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"activityToast\":\"src-modules-desktop-modules-files-integration-components-FileUploadProgressToast-FileUploadProgressToast-module__activityToast-GFFmD1\"}";
        // 1793873552533
        var cssReload = require("../../../../../../../node_modules/.pnpm/@rspack+core@1.5.8_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  